import React from 'react'
import './services.css';
const Services = () => {
  return (
    <div>
      SERVICES
    </div>
  )
}

export default Services
